import { create } from 'zustand'

interface UiState {
  navOpen: boolean
  paletteOpen: boolean
  setNavOpen: (v: boolean) => void
  setPaletteOpen: (v: boolean) => void
  togglePalette: () => void
}

export const useUiStore = create<UiState>((set) => ({
  navOpen: false,
  paletteOpen: false,
  setNavOpen: (v) => set({ navOpen: v }),
  setPaletteOpen: (v) => set({ paletteOpen: v }),
  togglePalette: () => set((s) => ({ paletteOpen: !s.paletteOpen })),
}))
